if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const silentAdd = evt.submitter?.dataset.silentAdd === 'true';
        const notifyResult = (success, message = '') => { if(silentAdd) document.dispatchEvent(new CustomEvent('suminagashi:cart-result',{detail:{formId:this.form.id,success,message}})); };
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        const engraving = this.form.querySelector('suminagashi-engraving');
        const engravingEnabled = engraving?.querySelector('[data-engraving-toggle]')?.checked;
        const engravingText = engraving?.querySelector('[data-engraving-input]')?.value.trim();
        if (engravingEnabled && (!engravingText || !engraving.dataset.variantId)) {
          this.handleErrorMessage(!engravingText ? 'Indiquez le nom ou les initiales à graver.' : 'La gravure est momentanément indisponible.');
          engraving.querySelector('[data-engraving-input]')?.focus();
          notifyResult(false, 'Vérifiez votre personnalisation.');
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const productVariantId = formData.get('id');
        const sharpening = window.SuminagashiSharpening;
        const includesSharpening = sharpening && sharpening.variantIds.includes(Number(productVariantId));
        if (includesSharpening || engravingEnabled) {
          const quantity = formData.get('quantity') || '1';
          const bundleId = engravingEnabled ? 'gravure-' + Date.now() + '-' + Math.random().toString(36).slice(2,8) : '';
          for (const [key, value] of Array.from(formData.entries())) {
            if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
              const itemKey = key.startsWith('properties[') ? 'items[0][properties]' + key.slice(10) : 'items[0][' + key + ']';
              formData.append(itemKey, value);
              formData.delete(key);
            }
          }
          formData.set('items[0][quantity]', quantity);
          let next = 1;
          if (includesSharpening) {
            formData.append('items['+next+'][id]', sharpening.variantId);
            formData.append('items['+next+'][quantity]', quantity);
            formData.append('items['+next+'][properties][_suminagashi_affutage]', 'inclus');
            next++;
          }
          if (engravingEnabled) {
            const style = engraving.querySelector('[data-engraving-font]').selectedOptions[0].textContent;
            formData.set('items[0][properties][Gravure sur lame]', engravingText);
            formData.set('items[0][properties][Style de gravure]', style);
            formData.set('items[0][properties][_gravure_groupe]', bundleId);
            formData.set('items[0][properties][_gravure_service]', engraving.dataset.variantId);
            formData.append('items['+next+'][id]', engraving.dataset.variantId);
            formData.append('items['+next+'][quantity]', quantity);
            formData.append('items['+next+'][properties][Texte à graver]', engravingText);
            formData.append('items['+next+'][properties][Style]', style);
            formData.append('items['+next+'][properties][Couteau associé]', engraving.dataset.productTitle);
            formData.append('items['+next+'][properties][_gravure_groupe]', bundleId);
            formData.append('items['+next+'][properties][_gravure_parent]', productVariantId);
          }
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.items) response = {...response.items[0], sections:response.sections};
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              notifyResult(false, response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart && !silentAdd) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: productVariantId });
            this.error = false;
            if (silentAdd) {
              if (this.cart) this.cart.renderContents(response, false);
              notifyResult(true);
              return;
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            if (this.closest('#SuminagashiQuickView')) this.handleErrorMessage('Connexion interrompue. Vérifiez votre panier avant de réessayer.');
            notifyResult(false, 'Connexion interrompue. Vérifiez votre panier avant de réessayer.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
